import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  AppBar,
  IconButton,
  Toolbar,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
const ForgotPasswordModal = ({ open, onClose }: any) => {
  const [email, setEmail] = useState("");

  const handleEmailChange = (e: any) => {
    setEmail(e.target.value);
  };

  const handleSendResetLink = () => {
    console.log(`Sending password reset link to ${email}`);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <AppBar
        position="sticky"
        elevation={0}
        className="forgot-password-app-bar"
      >
        <Toolbar>
          <Typography
            variant="h4"
            component="div"
            className="forgot-password-title"
          >
            Reset your Password
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <Typography margin={3}>
        Please reachout to Manoshala team on community@manoshala.com to reset your password.
        </Typography>
        {/* <TextField
          fullWidth
          label="Enter email address"
          type="email"
          value={email}
          onChange={handleEmailChange}
          margin="normal"
          className="forgot-password-email-input"
        /> */}
      </DialogContent>
   
    </Dialog>
  );
};

export default ForgotPasswordModal;
